import { Navigate, Outlet, useLocation } from 'react-router-dom';
// hooks
import useAuth from 'hooks/useAuth';

const PrivateRoutesOutlet = ({ redirectTo }) => {
  const location = useLocation();
  const { isLoggedIn, isRefreshing } = useAuth();
  const shouldRedirect = !isRefreshing && !isLoggedIn;

  return shouldRedirect ? (
    <Navigate to={redirectTo} replace state={{ from: location }} />
  ) : (
    <Outlet />
  );
};
export default PrivateRoutesOutlet;
